import React from 'react';
import PropTypes from 'prop-types';
import { i18next } from '@yola/ws-sdk';
import { reactHookForm, designSystem } from '@yola/ws-ui';
import ModalWithPanels from 'src/js/modules/common/components/modal-with-panels';

const { useForm } = reactHookForm;
const { ControlGroup, InputGroupField } = designSystem;

const MODAL_WIDTH = 360;
const MODAL_HEIGHT = 'auto';
const FIELD_NAME = 'slug';
const SLUG_PATTERN = /^[a-z][a-z0-9_]*$/;
const MAX_SLUG_LENGTH = 70;
const defaultBindings = [];

function ConnectToCmsDialog({ onSubmit, onCancel, existingSlug = '', bindings = defaultBindings }) {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      [FIELD_NAME]: existingSlug || '',
    },
  });

  const handleDialogSubmit = (values) => {
    onSubmit(values[FIELD_NAME].trim());
  };

  return (
    <ModalWithPanels
      width={MODAL_WIDTH}
      height={MODAL_HEIGHT}
      captions={{
        title: i18next.t('Connect to CMS'),
        submitButton: i18next.t('Submit'),
        cancelButton: i18next.t('Cancel'),
      }}
      overlay="visible"
      draggable={false}
      centered
      onSubmit={handleSubmit(handleDialogSubmit)}
      onCancel={onCancel}
      onOverlayClick={onCancel}
      onPressEsc={onCancel}
    >
      <ControlGroup title={i18next.t('Variable name')} required>
        <InputGroupField
          control={control}
          name={FIELD_NAME}
          maxLength={MAX_SLUG_LENGTH}
          rules={{
            required: i18next.t('This field is required'),
            pattern: {
              value: SLUG_PATTERN,
              message: i18next.t(
                'Variable name must start with a letter and contain only lowercase letters, digits, and underscores'
              ),
            },
            validate: (value) => {
              const trimmed = value.trim();
              const isDuplicate = bindings.some(
                (b) => b.slug === trimmed && b.slug !== existingSlug
              );
              return isDuplicate
                ? i18next.t('This variable name is already used on this page')
                : true;
            },
          }}
        />
      </ControlGroup>
    </ModalWithPanels>
  );
}

ConnectToCmsDialog.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  existingSlug: PropTypes.string,
  bindings: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
    })
  ),
};

export default ConnectToCmsDialog;
